import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import styles from "./Footer.module.css";

const Footer = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <footer
      className={`${styles.footer} ${theme === "dark" ? styles.dark : ""}`}
    >
      <div className="container">
        <div className="row">
          <div className={`col-md-4 ${styles.footerColumn}`}>
            <h4>About Us</h4>
            <p>
              Pixelmoon is your trusted platform for instant digital top-ups for
              your favorite games, gift cards, and subscriptions with secure
              payment options and 24/7 customer support.
            </p>
          </div>

          <div
            className={`col-md-4 ${styles.footerColumn} ${styles.linksSection}`}
          >
            <div className="row">
              <div className="col-6">
                <h4>Quick Links</h4>
                <ul className={styles.footerLinks}>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/games">Games</Link>
                  </li>
                  <li>
                    <Link to="/blogs">Blogs</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <a
                      href="http://www.softgear.live/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.highlightLink}
                    >
                      Developer Page
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-6">
                <h4>Popular Games</h4>
                <ul className={styles.footerLinks}>
                  <li>
                    <Link to="/games/mobile-legends">Mobile Legends</Link>
                  </li>
                  <li>
                    <Link to="/games/pubg">PUBG Mobile</Link>
                  </li>
                  <li>
                    <Link to="/games/free-fire">Free Fire</Link>
                  </li>
                  <li>
                    <Link to="/games/call-of-duty">Call of Duty Mobile</Link>
                  </li>
                  <li>
                    <Link to="/games/valorant">Valorant</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className={`col-md-4 ${styles.footerColumn}`}>
            <h4>Contact Us</h4>
            <ul className={styles.contactInfo}>
              <li>
                <a
                  href="mailto:support@pixelmoonstore.in"
                  className={styles.emailLink}
                >
                  Email: support@pixelmoonstore.in
                </a>
              </li>
              <li>Working Hours: 24/7 Support</li>
            </ul>

            <div className={styles.paymentMethods}>
              <h5>Payment Methods</h5>
              <div className={styles.paymentIcons}>
                <span className={styles.paymentIcon}>Razorpay</span>
                <span className={styles.paymentIcon}>Phonepe</span>
                <span className={styles.paymentIcon}>UPI</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p>
            &copy; {new Date().getFullYear()} PixelMoon. All Rights Reserved.
            Developed by{" "}
            <a
              href="http://www.softgear.live/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="SoftGear Technologies"
              style={{ color: "#a1f6ff", textDecoration: "underline" }}
            >
              SoftGear Technologies
            </a>
          </p>
          <div className={styles.footerBottomLinks}>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/refund">Refund Policy</Link>
            <Link to="/legal-notice">Legal Notice</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
